import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { useAuth, useSelectedAccount } from '@ibk/shared-auth';
import { useTranslation } from '@ibk/shared-translation';
import { LoginErrorsType } from '@ibk/shared-types';
import { operatorDrawerAuthenticateAtom } from '@ibk/shared-utils';
export function usePasswordInputModal() {
    const { t } = useTranslation();
    const { validatePassword, loading, error: authError } = useAuth();
    const setDrawerAuthenticated = useSetAtom(operatorDrawerAuthenticateAtom);
    const { selectedAccount } = useSelectedAccount();
    const [password, setPassword] = useState('');
    const [error, setError] = useState(undefined);
    const [showPassword, setShowPassword] = useState(false);
    const ERROR_MESSAGES = {
        [LoginErrorsType.MISSING_CREDENTIALS]: t('password-input-modal.errors.missing-credentials'),
        [LoginErrorsType.INVALID_CREDENTIALS_FOR_USER_PARTY_RELATIONSHIP]: t('password-input-modal.errors.invalid-credentials-for-user-party-relationship'),
        [LoginErrorsType.AUTH_TOKEN_EXPIRED]: t('password-input-modal.errors.auth-token-expired'),
        [LoginErrorsType.GENERIC]: t('password-input-modal.errors.generic'),
    };
    useEffect(() => {
        if (authError) {
            setError(ERROR_MESSAGES[authError] ?? t('password-input-modal.errors.generic'));
        }
    }, [authError]);
    const handlePassValidation = async () => {
        if (!selectedAccount) {
            return;
        }
        const result = await validatePassword(password, selectedAccount.id);
        setDrawerAuthenticated(result);
    };
    return {
        handlePassValidation,
        isLoading: loading,
        password,
        setPassword,
        showPassword,
        setShowPassword,
        error,
        setError,
    };
}
